import { render, staticRenderFns } from "./PendingFaultsDialog.vue?vue&type=template&id=39030668&scoped=true"
import script from "./PendingFaultsDialog.vue?vue&type=script&lang=js"
export * from "./PendingFaultsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39030668",
  null
  
)

export default component.exports